module.exports = __webpack_public_path__ + "static/media/right-shop-arrow.c8cf2fa7.png";